var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerPinCarpool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.998 36.341-.998.872-.998-.872C10.61 29.013 6.344 22.614 6.344 16.99 6.344 9.025 12.56 3.334 20 3.334s13.657 5.69 13.657 13.656c0 5.624-4.266 12.023-12.659 19.351z",
    fill: "#0C9F2C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 17,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20 39.425-2.094-1.829C9.483 30.242 4.676 23.408 4.676 16.99 4.677 8.061 11.683 1.666 20 1.666c8.317 0 15.323 6.395 15.323 15.322 0 6.419-4.806 13.253-13.229 20.607L20 39.426zm0-2.212.998-.872c8.392-7.328 12.658-13.727 12.658-19.352C33.656 9.024 27.44 3.333 20 3.333c-7.44 0-13.657 5.691-13.657 13.656 0 5.625 4.266 12.024 12.659 19.352l.998.871z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.524 11.341c.841 0 1.718.68 1.958 1.515l.324 1.128h1.014c.138 0 .25.113.25.267v.523c0 .147-.109.267-.25.267h-.71l.02.07c.028.101.047.2.055.294.535.38.885 1.023.885 1.755v4.225c0 .29-.224.526-.51.526h-1.002a.522.522 0 0 1-.511-.526v-.53h1.264c.422 0 .76-.355.76-.792v-1.451.923c0 .437-.338.79-.76.79H14.689c-.42 0-.76-.354-.76-.79v-.923 1.451c0 .436.34.791.76.791h1.264v.531c0 .29-.224.526-.51.526H14.44a.522.522 0 0 1-.51-.526V17.16c0-.73.35-1.373.885-1.754.008-.095.027-.194.055-.294l.02-.071h-.71c-.138 0-.25-.113-.25-.267v-.523c0-.148.109-.267.25-.267h1.014l.324-1.128c.24-.837 1.111-1.515 1.957-1.515h5.049zm-7.077 6.342c0-.292.225-.528.51-.528h1.003c.282 0 .51.234.51.528v.53a.517.517 0 0 1-.51.527h-1.002a.518.518 0 0 1-.51-.528v-.53zm7.082 0c0-.292.225-.528.51-.528h1.003c.282 0 .51.234.51.528v.53a.517.517 0 0 1-.51.527H23.04a.518.518 0 0 1-.51-.528v-.53zm-6-4.517c.1-.424.518-.768.937-.768h5.068c.416 0 .835.34.938.768l.575 2.403h-8.094l.575-2.403z",
    fill: "#425913"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.871 12.47a.863.863 0 0 0-.337-.072h-.453l-1.265 3.171h.818l1.237-3.099zm-.53 3.1h1.706l-.575-2.404a.938.938 0 0 0-.084-.22l-1.046 2.623zm-4.875-3.172h3.2L19.4 15.57h-3.447l.575-2.403c.102-.424.52-.768.938-.768zm-2.019 5.285c0-.292.225-.528.51-.528h1.003c.282 0 .51.234.51.528v.53a.517.517 0 0 1-.51.527h-1.002a.518.518 0 0 1-.51-.527v-.53zm7.082 0c0-.292.225-.528.51-.528h1.003c.282 0 .51.234.51.528v.53a.517.517 0 0 1-.51.527H23.04a.518.518 0 0 1-.51-.527v-.53z",
    fill: "#E0EFE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.361 14.77a.99.99 0 0 0 .985-.996.99.99 0 0 0-.985-.997.99.99 0 0 0-.984.997c0 .55.44.996.984.996zm1.641 1.329h-3.281c0-.734.595-1.329 1.328-1.329h.624c.734 0 1.329.595 1.329 1.329zm1.64-1.329h.312c.734 0 1.33.595 1.33 1.329h-3.282c0-.734.595-1.329 1.329-1.329h.312zm0 0a.99.99 0 0 1-.984-.996c0-.551.44-.997.985-.997a.99.99 0 0 1 .984.997.99.99 0 0 1-.984.996z",
    fill: "#425913"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -2,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerPinCarpool);
export default __webpack_public_path__ + "static/media/map-marker-pin-carpool.953b8ccad796995e1181a39cc4627f89.svg";
export { ForwardRef as ReactComponent };